import {useEffect, useState} from "react";
import {getSessionStatus, subscribeSession} from "./keycloak";

export default function useSessao() {
    const [session, setSession] = useState(getSessionStatus);
    useEffect(() => {
        const update = () => setSession(getSessionStatus());
        const unsubscribe = subscribeSession(update);
        update();
        return unsubscribe;
    }, []);
    return session;
}
